import React from 'react';
import propTypes from 'prop-types';
import { get } from 'lodash';
import SearchTypeaheadPicker from './SearchTypeaheadPicker';
import styles from './TypeaheadPicker.styles';

const FormikTypeaheadPicker = ({
  field: { name, value },
  form: { setFieldValue, errors },
  Typeahead = SearchTypeaheadPicker,
  showErrors = false,
  onChange = () => {},
  ...others
}) => {
  const error = get(errors, name);

  return (
    <>
      <Typeahead
        selectedValue={value}
        onChange={newValue => {
          setFieldValue(name, newValue);
          onChange(newValue);
        }}
        {...others}
      />
      {showErrors && error && (
        <div>
          <p className={styles.errorMessage}>
            <span data-automation-id="error-message">
              {typeof error === 'object' && JSON.stringify(error).includes('Required')
                ? 'Required'
                : error}
            </span>
          </p>
        </div>
      )}
    </>
  );
};

FormikTypeaheadPicker.propTypes = {
  field: propTypes.shape({
    name: propTypes.string.isRequired,
    value: propTypes.any,
  }).isRequired,
  form: propTypes.shape({
    setFieldValue: propTypes.func.isRequired,
    errors: propTypes.object.isRequired,
  }).isRequired,
  Typeahead: propTypes.func,
  showErrors: propTypes.bool,
  onChange: propTypes.func,
};

FormikTypeaheadPicker.defaultProps = {
  Typeahead: SearchTypeaheadPicker,
  showErrors: false,
  onChange: () => {},
};

export default FormikTypeaheadPicker;
